import React from 'react';
import { CheckIcon, CloudSunIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-celeste/20 bg-abyss/40 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0bjea05oib">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15ckg2l9o5u77">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-60" data-mp="1jcv8hsqmnguh">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed0h7o2xwp8w">
            <CloudSunIcon className="h-8 w-8 shrink-0 text-celeste drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-62" data-mp="1t2omf0e8s81w" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-gold sm:text-2xl" data-id="element-63" data-mp="1o4n26c52y2ou">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-mist" data-id="element-64" data-mp="1x5kx84xjizva">
          Creata per insegnanti di scienze e geografia della scuola secondaria.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="s45te5xk5lvt">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mist" data-id="element-66" data-mp="122vc20xa3ad4">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="1658h0n47b48u">
              <CheckIcon className="h-4 w-4 text-celeste drop-shadow-[0_0_6px_rgba(94,200,242,0.55)]" aria-hidden="true" data-id="element-68" data-mp="1b39zp6xpt1js" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}